"use client";
import { createPath } from "@/service/routing/routing";
import { isDateInFuture } from "@/service/date/compare";
import { PackageButton } from "@/components/ecommerce/package-button";
import { VerticalCard } from "@/components/common/vertical-card/vertical-card";
import { InfoIcon, PlayIcon } from "lucide-react";
import { useRouter } from "@bprogress/next";
import { renderMoney } from "@/service/ecommerce/currency";
import { trans } from "@/service/i18n/i18n";
import { ComplexBuyButton } from "../../ecommerce/complex-buy-button";

export const CourseCard = ({
  course,
  onClick,
}: {
  course: CoursePreviewVM;
  onClick?: () => void;
}) => {
  const {
    image,
    title,
    subtitle,
    product,
    slug,
    id,
    publishedAt,
    isOwned,
    exclusiveAccess,
    isFreebie,
  } = course;

  const preorder = isDateInFuture(publishedAt);
  const router = useRouter();

  // Badge for pre-order
  const absoluteExtras = preorder ? (
    <div className="absolute top-4 right-4 z-10 rounded bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800">
      Przedsprzedaż
    </div>
  ) : undefined;

  // Extras section (e.g. package options)
  const extras = (
    <div className="flex flex-1 flex-col justify-end">
      {product && !product.inCart && (
        <div className="my-2">
          {product.promotionPrice != product.price && (
            <div className="flex items-center gap-2">
              <InfoIcon className="text-muted-foreground h-4 w-4" />
              <div className="flex items-center gap-1">
                <span
                  className={"text-xs font-medium text-rose-600 line-through"}
                >
                  {renderMoney(product.price)}
                </span>
                {product.omnibusPrice && (
                  <span
                    className={"text-muted-foreground text-xs font-medium"}
                    data-title={`${trans(
                      "ecommerce.omnibus_30_days",
                    )}: ${renderMoney(product.omnibusPrice)}`}
                  >
                    {trans("ecommerce.lowest_price")}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      {product && !product.inCart && !isOwned && product.packages ? (
        <div onClick={(e) => e.stopPropagation()} className="w-full">
          <PackageButton packages={product.packages} />
        </div>
      ) : undefined}
    </div>
  );

  return (
    <div
      className="relative z-0 h-full cursor-pointer"
      onClick={() => {
        if (onClick) onClick();
        router.push(createPath("course.show", { slug, id }));
      }}
    >
      <VerticalCard
        image={image}
        title={title}
        subtitle={subtitle}
        absoluteExtras={absoluteExtras}
        extras={extras}
        button={
          <div onClick={(e) => e.stopPropagation()} className="w-full">
            <ComplexBuyButton
              product={product}
              isOwned={isOwned}
              exclusiveAccess={exclusiveAccess}
              publishedAt={publishedAt}
              slug={slug}
              id={id}
              title={title}
              isFreebie={isFreebie}
            />
          </div>
        }
        hoverIcon={<PlayIcon className="h-4 w-4" />}
      />
    </div>
  );
};
